/**
 * AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPage
 */

import { useAlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageLogic } from '@/hooks/traits/useAlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageLogic';
import type { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageConfig } from '@/hooks/traits/useAlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostView as AlmadarPostWhatIfSoftwareCouldBuildItselfENPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostHeaderView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfENPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfENPostView';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostFooterView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfENPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageViewProps {
  config?: Partial<AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageConfig>;
}

export function AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView({ config: propsConfig }: AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhatIfSoftwareCouldBuildItselfENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhatIfSoftwareCouldBuildItselfEN" trait="AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostWhatIfSoftwareCouldBuildItselfENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" paddingY="xl"><Container size="xl" maxWidth="xl" padding="lg"><AlmadarPostWhatIfSoftwareCouldBuildItselfENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhatIfSoftwareCouldBuildItselfENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView;
